// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Animación de personaje 8-bit */
.character-scene {
    position: relative;
    width: 100%;
    height: 300px;
    overflow: hidden;
    background: linear-gradient(to bottom, #5a7942 0%, #E0F6FF 100%);
    margin: 0;
    padding: 0;
}

/* Fondo animado - capa más lejana del parallax */
.scene-background {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 100%;
    display: flex;
    z-index: 0;
}

.background-tile {
    height: 100%;
    width: auto;
    image-rendering: pixelated;
    image-rendering: -moz-crisp-edges;
    image-rendering: crisp-edges;
    opacity: 0.4;
}

/* Nubes */
.clouds {
    position: absolute;
    top: 20px;
    left: 0;
    height: 80px;
    display: flex;
    gap: 100px;
    z-index: 1;
}

.cloud {
    height: 60px;
    width: auto;
    image-rendering: pixelated;
    image-rendering: -moz-crisp-edges;
    image-rendering: crisp-edges;
    opacity: 0.6;
}

/* Elementos del escenario (árboles) */
.scenery {
    position: absolute;
    bottom: 80px;
    left: 0;
    height: 110px;
    display: flex;
    gap: 150px;
    z-index: 2;
}

.tree {
    height: 120px;
    width: auto;
    image-rendering: pixelated;
    image-rendering: -moz-crisp-edges;
    image-rendering: crisp-edges;
}

/* Personaje */
.character {
    position: absolute;
    bottom: 80px;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 80px;
    z-index: 3;
}

.character-sprite {
    position: absolute;
    width: 100%;
    height: 100%;
    image-rendering: pixelated;
    image-rendering: -moz-crisp-edges;
    image-rendering: crisp-edges;
}

.sprite-1 {
    animation: walk-sprite-1 0.6s steps(1) infinite;
}

.sprite-2 {
    animation: walk-sprite-2 0.6s steps(1) infinite;
}

@keyframes walk-sprite-1 {
    0%, 49% { opacity: 1; }
    50%, 100% { opacity: 0; }
}

@keyframes walk-sprite-2 {
    0%, 49% { opacity: 0; }
    50%, 100% { opacity: 1; }
}

/* Suelo */
.ground {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 80px;
    display: flex;
    z-index: 4;
}

.ground-tile {
    height: 100%;
    width: auto;
    image-rendering: pixelated;
    image-rendering: -moz-crisp-edges;
    image-rendering: crisp-edges;
}

/* Responsive */
@media (max-width: 768px) {
    .character-scene {
        height: 300px;
    }
    
    .character {
        width: 60px;
        height: 60px;
        bottom: 70px;
    }
    
    .tree {
        height: 90px;
    }
    
    .scenery {
        bottom: 60px;
        gap: 100px;
    }
    
    .clouds {
        gap: 60px;
    }
    
    .cloud {
        height: 40px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/character-animation.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,gEAAgE;IAChE,SAAS;IACT,UAAU;AACd;;AAEA,iDAAiD;AACjD;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,YAAY;IACZ,aAAa;IACb,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,0BAA0B;IAC1B,iCAAiC;IACjC,4BAA4B;IAC5B,YAAY;AAChB;;AAEA,UAAU;AACV;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,YAAY;IACZ,aAAa;IACb,UAAU;IACV,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,0BAA0B;IAC1B,iCAAiC;IACjC,4BAA4B;IAC5B,YAAY;AAChB;;AAEA,sCAAsC;AACtC;IACI,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,aAAa;IACb,aAAa;IACb,UAAU;IACV,UAAU;AACd;;AAEA;IACI,aAAa;IACb,WAAW;IACX,0BAA0B;IAC1B,iCAAiC;IACjC,4BAA4B;AAChC;;AAEA,cAAc;AACd;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,iCAAiC;IACjC,4BAA4B;AAChC;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,UAAU,UAAU,EAAE;IACtB,YAAY,UAAU,EAAE;AAC5B;;AAEA;IACI,UAAU,UAAU,EAAE;IACtB,YAAY,UAAU,EAAE;AAC5B;;AAEA,UAAU;AACV;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,YAAY;IACZ,aAAa;IACb,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,0BAA0B;IAC1B,iCAAiC;IACjC,4BAA4B;AAChC;;AAEA,eAAe;AACf;IACI;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,UAAU;IACd;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,YAAY;IAChB;AACJ","sourcesContent":["/* Animación de personaje 8-bit */\n.character-scene {\n    position: relative;\n    width: 100%;\n    height: 300px;\n    overflow: hidden;\n    background: linear-gradient(to bottom, #5a7942 0%, #E0F6FF 100%);\n    margin: 0;\n    padding: 0;\n}\n\n/* Fondo animado - capa más lejana del parallax */\n.scene-background {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    height: 100%;\n    display: flex;\n    z-index: 0;\n}\n\n.background-tile {\n    height: 100%;\n    width: auto;\n    image-rendering: pixelated;\n    image-rendering: -moz-crisp-edges;\n    image-rendering: crisp-edges;\n    opacity: 0.4;\n}\n\n/* Nubes */\n.clouds {\n    position: absolute;\n    top: 20px;\n    left: 0;\n    height: 80px;\n    display: flex;\n    gap: 100px;\n    z-index: 1;\n}\n\n.cloud {\n    height: 60px;\n    width: auto;\n    image-rendering: pixelated;\n    image-rendering: -moz-crisp-edges;\n    image-rendering: crisp-edges;\n    opacity: 0.6;\n}\n\n/* Elementos del escenario (árboles) */\n.scenery {\n    position: absolute;\n    bottom: 80px;\n    left: 0;\n    height: 110px;\n    display: flex;\n    gap: 150px;\n    z-index: 2;\n}\n\n.tree {\n    height: 120px;\n    width: auto;\n    image-rendering: pixelated;\n    image-rendering: -moz-crisp-edges;\n    image-rendering: crisp-edges;\n}\n\n/* Personaje */\n.character {\n    position: absolute;\n    bottom: 80px;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 80px;\n    height: 80px;\n    z-index: 3;\n}\n\n.character-sprite {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    image-rendering: pixelated;\n    image-rendering: -moz-crisp-edges;\n    image-rendering: crisp-edges;\n}\n\n.sprite-1 {\n    animation: walk-sprite-1 0.6s steps(1) infinite;\n}\n\n.sprite-2 {\n    animation: walk-sprite-2 0.6s steps(1) infinite;\n}\n\n@keyframes walk-sprite-1 {\n    0%, 49% { opacity: 1; }\n    50%, 100% { opacity: 0; }\n}\n\n@keyframes walk-sprite-2 {\n    0%, 49% { opacity: 0; }\n    50%, 100% { opacity: 1; }\n}\n\n/* Suelo */\n.ground {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    height: 80px;\n    display: flex;\n    z-index: 4;\n}\n\n.ground-tile {\n    height: 100%;\n    width: auto;\n    image-rendering: pixelated;\n    image-rendering: -moz-crisp-edges;\n    image-rendering: crisp-edges;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n    .character-scene {\n        height: 300px;\n    }\n    \n    .character {\n        width: 60px;\n        height: 60px;\n        bottom: 70px;\n    }\n    \n    .tree {\n        height: 90px;\n    }\n    \n    .scenery {\n        bottom: 60px;\n        gap: 100px;\n    }\n    \n    .clouds {\n        gap: 60px;\n    }\n    \n    .cloud {\n        height: 40px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
